import type { ReactElement } from 'react';
import { formatBall } from '../lib/format';

interface BallsProps {
  main: readonly number[];
  bonus: readonly number[];
  bonusLabel: string;
  small?: boolean;
  /** Numbers to outline as matching a published result. */
  hitMain?: readonly number[];
  hitBonus?: readonly number[];
}

export function Balls({
  main,
  bonus,
  bonusLabel,
  small = false,
  hitMain = [],
  hitBonus = [],
}: BallsProps): ReactElement {
  const size = small ? ' small' : '';
  const hitM = new Set(hitMain);
  const hitB = new Set(hitBonus);
  return (
    <div className="balls">
      {main.map((n) => (
        <span key={`m${n}`} className={`ball${size}${hitM.has(n) ? ' hit' : ''}`}>
          {formatBall(n)}
        </span>
      ))}
      {bonus.length > 0 && (
        <>
          <span className="ball-sep" aria-hidden="true">
            ·
          </span>
          {bonus.map((n) => (
            <span
              key={`b${n}`}
              className={`ball bonus${size}${hitB.has(n) ? ' hit' : ''}`}
              title={bonusLabel}
              aria-label={`${bonusLabel} ${n}`}
            >
              {formatBall(n)}
            </span>
          ))}
        </>
      )}
    </div>
  );
}
